import script from "./goRinSyo0026.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0026.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0026.vue?vue&type=style&index=0&id=24907eb8&lang=scss"

const __exports__ = script;

export default __exports__